import COLOR_CHOICES from './colors'

import { MENU as MENU_FOR_3D, SHAPES as SHAPES_FOR_3D } from './shapesFor3D'
import { MENU as MENU_FOR_45DEG, SHAPES as SHAPES_FOR_45DEG } from './shapesFor45deg'
import { MENU as MENU_FOR_FREEFORM, SHAPES as SHAPES_FOR_FREEFORM } from './shapesForFreeform'
import { MENU as MENU_FOR_HEX, SHAPES as SHAPES_FOR_HEX } from './shapesForHex'
import { MENU as MENU_FOR_HEX_90, SHAPES as SHAPES_FOR_HEX_90 } from './shapesForHex90'
import { MENU as MENU_FOR_HEX_SPACED, SHAPES as SHAPES_FOR_HEX_SPACED } from './shapesForHexSpaced'
import { MENU as MENU_FOR_SQUARE, SHAPES as SHAPES_FOR_SQUARE } from './shapesForSquare'

const GRID_SHAPES = {
  'square': SHAPES_FOR_SQUARE,
  '45-deg': SHAPES_FOR_45DEG,
  'hex': SHAPES_FOR_HEX,
  'hex-90': SHAPES_FOR_HEX_90,
  'hex-spaced': SHAPES_FOR_HEX_SPACED,
  'freeform': SHAPES_FOR_FREEFORM,
  '3d': SHAPES_FOR_3D,
}

const GRID_MENU = {
  'square': MENU_FOR_SQUARE,
  '45-deg': MENU_FOR_45DEG,
  'hex': MENU_FOR_HEX,
  'hex-90': MENU_FOR_HEX_90,
  'hex-spaced': MENU_FOR_HEX_SPACED,
  'freeform': MENU_FOR_FREEFORM,
  '3d': MENU_FOR_3D,
}

export { COLOR_CHOICES, GRID_MENU, GRID_SHAPES }
